<template>
  <div class="switch-view-mode">
    <button
      class="switch-view-mode__value switch-view-mode__value--gallery"
      title="В режиме галерии"
      type="button"
      v-bind:class="{ selected: $options.galleryMode === value }"
      v-bind:disabled="disabled"
      v-on:click="emitSelected($options.galleryMode)"
    />
    <button
      class="switch-view-mode__value switch-view-mode__value--table"
      title="В режиме таблицы"
      type="button"
      v-bind:class="{ selected: $options.tableMode === value }"
      v-bind:disabled="disabled"
      v-on:click="emitSelected($options.tableMode)"
    />
  </div>
</template>

<script>

/**
 * @description Режим галерии.
 * @type {string}
 */
export const GALLERY_MODE = 'gallery';

/**
 * @description Режим таблицы.
 * @type {string}
 */
export const TABLE_MODE = 'table';
export default {
  /**
   * @description Переключатель режима отображения.
   */
  name: 'switch-view-mode',
  galleryMode: GALLERY_MODE,
  tableMode: TABLE_MODE,
  methods: {
    /**
     * @description Отправить событие выбора.
     * @param {string} value
     * @returns {void}
     */
    emitSelected(value) {
      this.$emit('input', value);
    },
  },
  props: {
    /**
     * @description Деактивирован.
     * @type {boolean}
     */
    disabled: { default: () => false, type: Boolean },
    /**
     * @description Значение.
     * @type {string}
     */
    value: {
      required: true,
      type: String,
      validator: (value) => [
        GALLERY_MODE,
        TABLE_MODE,
      ].includes(value),
    },
  },
};
</script>

<style  lang="scss">

.switch-view-mode {
  display: flex;
  &__value {
    height: 1.5rem;
    width: 1.5rem;
    padding: 5px;
    background-color: #EAEFF3;
    background-size: 70%;
    background-position: center;
    border: 1px solid #C2CFE0;
    &:hover {
      background-color: #0076c4;
    }
    &:disabled {
      cursor: inherit !important;
      pointer-events: none;
    }
    &.selected {
      background-color: #0489E0;
      border: 1px solid #0489E0;
    }
    &--table {
      background-image: url("@/assets/img/switch/table-black.svg");
      border-radius: 2px 0 0 2px;
      &.selected,
      &:hover {
        background-image: url("@/assets/img/switch/table-white.svg");
      }
    }
    &--gallery {
      background-image: url("@/assets/img/switch/picture-black.svg");
      border-radius: 0 2px 2px 0;
      &.selected,
      &:hover {
        background-image: url("@/assets/img/switch/picture-white.svg");
      }
    }
  }
}
.switch {
  display: flex;
  &__value {
    &.selected {
      background-color: var(--action-color);
      color: white;
    }
  }
}
</style>
